import React from 'react';
import { Modal, ModalHeader, ModalContent, ModalFooter } from '@heroui/react';
import { XIcon } from "@phosphor-icons/react";
import { hotkeysList } from './hot-keys';
interface HotkeysModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}
const HotkeysModal = ({
  isOpen,
  onOpenChange
}: HotkeysModalProps) => {
  const renderKeys = (shortcut: {
    keys: (string[] | string)[];
    divider?: string;
  }) => {
    return shortcut.keys.map((keyGroup, groupIdx, groups) => <React.Fragment key={groupIdx}>
        {Array.isArray(keyGroup) ?
      // Handle key combinations
      keyGroup.map((key, keyIdx, arr) => <React.Fragment key={keyIdx}>
              <span className={`kbd ${key.length > 1 ? 'px-1' : ''} ${['↑', '↓', '←', '→'].includes(key) ? 'text-[16px]' : ''}`}>
                {key}
              </span>
              {keyIdx < arr.length - 1 && <span className="text-white/65 mx-1">+</span>}
            </React.Fragment>) :
      // Handle single keys
      <span className={`kbd ${keyGroup.length > 1 ? 'px-1' : ''} ${['↑', '↓', '←', '→'].includes(keyGroup) ? 'text-[16px]' : ''}`}>
            {keyGroup}
          </span>}
        {groupIdx < groups.length - 1 && <span className="text-white/65 mx-1">
            {shortcut.divider || '+'}
          </span>}
      </React.Fragment>);
  };
  return <Modal isOpen={isOpen} onOpenChange={onOpenChange} aria-labelledby="hotkeys-modal-title" classNames={{
    base: 'bg-[#09121E] text-white p-6 rounded-lg shadow-lg w-[500px] max-h-[80vh] overflow-y-auto',
    body: '',
    closeButton: 'text-white/65 hover:text-white bg-transparent hover:bg-white/5 hover:cursor-pointer focus:outline-none btn-h rounded-md',
    backdrop: 'bg-black/75'
  }} data-sentry-element="Modal" data-sentry-component="HotkeysModal" data-sentry-source-file="hotkeys-modal.tsx">
      <ModalContent data-sentry-element="ModalContent" data-sentry-source-file="hotkeys-modal.tsx">
        <div className="space-y-6">
          <h2 id="hotkeys-modal-title" className="text-xl text-blue-400 font-bold m-0 p-0 border-b border-blue-200 border-solid pb-1 w-full">
            Keyboard Shortcuts
          </h2>
          {hotkeysList.map((section, index) => <div key={index}>
              <h3 className="text-base text-blue-400 font-semibold mb-2">{section.section}</h3>
              <div className="space-y-2">
                {section.shortcuts.map((shortcut, idx) => <div key={idx} className="flex justify-between items-center">
                    <span>{shortcut.description}</span>
                    <div className="flex items-center gap-1">
                      {renderKeys(shortcut)}
                    </div>
                  </div>)}
              </div>
            </div>)}
        </div>
      </ModalContent>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="hotkeys-modal.tsx"></ModalFooter>
    </Modal>;
};
export default HotkeysModal;